export default __webpack_public_path__ + "static/tek_img_06-babaadaf0cda4d37f684b8391b86c542.webp";